import Domain from 'domain-service'
import Env from 'env-service'
import App from './App.vue'
import GuiBus from 'gui-bus-plugin'
;(async () => {
  function loadScript(scrpt) {
    return new Promise(resolve => {
      scrpt.addEventListener('load', resolve)
      document.head.appendChild(scrpt)
    })
  }

  let scriptPromises = []
  // Load externalized Vuetify JS files - make sure they load only once and leverage browser cache
  if (typeof window.Vuetify != 'function') {
    window.Vuetify = () => {}
    const scrpt = document.createElement('script')
    scrpt.setAttribute('src', '/assets/v1/vuetify.min.js') // This url must not contain version number, to allow for hot-swapping
    // ensure that Vuetify is loaded before going next step
    scriptPromises.push(loadScript(scrpt))
  }
  if (typeof VuetifyAdacadoTheme != 'object') {
    const scrpt = document.createElement('script')
    scrpt.setAttribute('src', '/assets/v1/vuetifyAdacadoTheme.js') // This url must not contain version number, to allow for hot-swapping
    // ensure that VuetifyAdacadoTheme is loaded before going next step
    scriptPromises.push(loadScript(scrpt))
  }
  await Promise.all(scriptPromises)

  // Load unbundled CSS - make sure they load only once and leverage browser cache
  const cssAssets = [
    '/assets/v1/materialdesignicons.min.css',
    '/assets/v1/roboto-fontface.css',
    '/assets/v1/vuetify.min.css',
    '/assets/v1/adacado.css',
  ]
  const stylesheets = Array.from(document.styleSheets)
  cssAssets
    // Document.styleSheets uses full urls, so we transform above paths to full urls
    .map(cssAsset => {
      if (Env.IS_LOCAL_CONNECTION) {
        // For local servers (dev) we must prepend localhost manually, there are no functions to do this
        // as we only ever do this here
        return `https://localhost:8080${cssAsset}`
      } else {
        // For staging/prod environments we use the Domain service to prepend domain to path
        return Domain.decorateWithApplicationDomain`${cssAsset}`
      }
    })
    .forEach(cssAsset => {
      if (!stylesheets.find(s => s.href == cssAsset)) {
        const newStyleTag = document.createElement('link')
        newStyleTag.rel = 'stylesheet'
        newStyleTag.href = cssAsset
        document.head.appendChild(newStyleTag)
      }
    })

  Vue.use(GuiBus)
  Vue.config.productionTip = false
  Vue.use(Vuetify)

  // Attach render function to window
  window.adacado_render_functions = window.adacado_render_functions || {}
  let containerId = undefined
  // femsName and femsVersion are injected by webpack - see vue.config.js
  // eslint-disable-next-line
window.adacado_render_functions[`${__femsName__}_${__femsVersion__}`] = c => {
    containerId = c
    init()
  }

  function init() {
    // Proceed to instantiate application only if:
    // - Firebase onAuthStateChanged has fired
    // - FEMS application render function has fired
    if (containerId != undefined) {
      const parentContainer = document.getElementById(containerId)
      const childContainer = parentContainer && parentContainer.querySelector('div')
      new Vue({
        vuetify: new Vuetify({
          theme: {
            themes: VuetifyAdacadoTheme,
          },
        }),
        el: childContainer || parentContainer,
        render(h) {
          return h(App, { props: { dataset: parentContainer.dataset } })
        },
      })
    }
  }
})()
